import {Arr, Bool, Num, Obj, OptNum, OptStr, Str} from '@repo/shared/api/core/api_schema';
import type {SchemaToType} from '@repo/shared/api/core/api_schema';

const NzbMediaTrackSchema = Obj({
  number: Num(),
  uid: OptStr(),
  codec: Str(),
  name: OptStr(),
  language: OptStr(),
  languageLegacy: OptStr(),
  languageBcp47: OptStr(),
  languageSource: Str<'bcp47' | 'iso639-2' | 'absent'>(),
  enabled: Bool(),
  default: Bool(),
  forced: Bool(),
  hearingImpaired: Bool(),
  visualImpaired: Bool(),
  commentary: Bool(),
  channels: OptNum(),
  samplingFrequency: OptNum(),
  outputSamplingFrequency: OptNum(),
  bitDepth: OptNum(),
});
export type NzbMediaTrack = SchemaToType<typeof NzbMediaTrackSchema>;

// Availability success/failure counts remain independent of this optional enrichment.
export const NzbMediaMetadataSchema = Obj({
  version: Num(),
  status: Str<'complete' | 'error' | 'skipped' | 'suspicious'>(),
  errorCode: OptStr(),
  reason: OptStr(),
  referencedBytes: OptNum(),
  container: OptStr(),
  packaging: OptStr(),
  mediaFile: OptStr(),
  audioTracks: Arr(NzbMediaTrackSchema),
  subtitleTracks: Arr(NzbMediaTrackSchema),
  stats: Obj({
    articles: Num(),
    encodedBodyBytes: Num(),
    decodedBytes: Num(),
    durationMs: Num(),
  }),
});
export type NzbMediaMetadata = SchemaToType<typeof NzbMediaMetadataSchema>;
